// @flow
import { connect } from 'react-redux'
import PriceBudgetForm from './PriceBudgetForm'
import type { Store } from '../../redux/ducks'
import * as priceBudgetFormReducer from '../../redux/ducks/priceBudgetForm/reducers'
import type { State } from '../../redux/ducks/priceBudgetForm/reducers'
import postJson from '../../services/postJson'
import store from '../../redux/store'
import { priceBudgetUpdateUrl } from '../CampaignsTable'

function mapStateToProps(state: Store) {
  return state.priceBudgetForm
}

function mapDispatchToProps(dispatch: Function, ownProps) {
  return {
    onChange: (diff: $Shape<State>) => {
      dispatch(priceBudgetFormReducer.patch(diff))
    },
    onApply: () => {
      const state = store.getState()
      const { paramToChange, changeType, valueChangeType, value } = state.priceBudgetForm
      const data = {
        audience_ids: state.campaignTable.checkedAudiencesIds,
        param_to_change: paramToChange,
        change_type: changeType,
        value_change_type: valueChangeType,
        value: parseFloat(value)
      }
      dispatch(priceBudgetFormReducer.patch({ isLoading: true }))
      postJson(priceBudgetUpdateUrl, { data: data })
        .done((response) => {
          ownProps.onUpdateAudienceState(response.data.audiences, data.audience_ids)
          ownProps.onCloseModal()
          window.alert(response.data.result_text.join('\n'))
        })
        .fail((e: any) => {
          if (e.status === 422) {
            dispatch(priceBudgetFormReducer.patch(processErrors(e.responseJSON.message)))
          } else {
            window.alert('Internal error')
          }
        })
        .always(() => {
          dispatch(priceBudgetFormReducer.patch({ isLoading: false }))
        })
    }
  }
}

function processErrors(errors) {
  return {
    paramToChangeErrors: errors.param_to_change || [],
    changeTypeErrors: errors.change_type || [],
    valueChangeTypeErrors: errors.value_change_type || [],
    valueErrors: errors.value || []
  }
}

const PriceBudgetFormContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PriceBudgetForm)

export default PriceBudgetFormContainer
